import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { ModuleLabel, StyledDialogTitle } from './styles';

const ModulesHintDialog = props => {
  const { isOpen, onAccept, onCancel, changedModules } = props;

  const closeDialog = () => {
    onCancel(false);
  };

  const modulesLabel = changedModules.map(cm => `"${cm.label}"`).join(', ');

  return (
    <Dialog
      open={isOpen}
      onClose={closeDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <StyledDialogTitle
        id="alert-dialog-title"
      >
        Changes will be applied to all sub projects
      </StyledDialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
        >
          <div>
            <ModuleLabel>{modulesLabel}</ModuleLabel>
            <span>{` module${changedModules.length > 1 ? 's have' : ' has'} been changed`}</span>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog} variant="outlined" color="primary">
          Cancel
        </Button>
        <Button onClick={onAccept} variant="contained" color="secondary" autoFocus>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModulesHintDialog;
